import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isArray'
})
export class IsArrayPipe implements PipeTransform {
  public transform(value: Record<string, any>, args?: any): boolean {
    return Array.isArray(value);
  }
}
